import { cn } from "@/lib/utils";

export function NavPreviewFrame({
  children,
  className,
  contentClassName,
  gradientClassName,
}: {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  gradientClassName?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-ds-m border-grey-100 bg-grey-0 relative h-[272px] w-[400px] shrink-0 overflow-hidden border",
        className
      )}
    >
      {gradientClassName ? (
        <div
          aria-hidden
          className={cn(
            "pointer-events-none absolute -inset-16 opacity-90",
            gradientClassName
          )}
        />
      ) : null}
      <div
        className={cn(
          "relative z-[1] flex h-full w-full items-center justify-center p-10",
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
}
